import vtkXMLImageDataReader from './XMLImageDataReader';
import vtkXMLImageDataWriter from './XMLImageDataWriter';
import vtkXMLPolyDataReader from './XMLPolyDataReader';
import vtkXMLPolyDataWriter from './XMLPolyDataWriter';
import vtkXMLReader from './XMLReader';
import vtkXMLWriter from './XMLWriter';

export default {
  vtkXMLImageDataReader,
  vtkXMLImageDataWriter,
  vtkXMLPolyDataReader,
  vtkXMLPolyDataWriter,
  vtkXMLReader,
  vtkXMLWriter,
};
